import PaymentMeans from '@/generated/classes/PaymentMeans';
export default class PaymentMeansExtend extends PaymentMeans {
  constructor() {
    super();
  }
}
